import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from './App';
import PrivacyPolicy from "./PrivacyPolicy";
import HolaReparto from "./HolaReparto";
import ScrollToTop from "./components/ScrollToTop";
import DocumentMeta from "./components/DocumentMeta";
import "./i18n";
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <DocumentMeta />
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/holareparto" element={<HolaReparto />} />
        <Route path="/admin" element={<p>Admin</p>} />
        <Route path="/dashboard" element={<p>Dashboard</p>} />
        <Route path="/settings" element={<HolaReparto />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);